@let ast = asset();


@switch (mode()) {
  @case ('thumbnail') {
    <i class="fa-solid fa-diagram-project"></i>
  }
  @case ('view') {
    <app-visjs-graph [asset]="ast" width="100%" height="500px"/>
  }
  @case ('details') {
    <dl class="mt-2">
      <div class="row">
        <dt>Storage path:</dt>
        <dd>{{ ast.storagePath }}</dd>
      </div>
      <div class="row">
        <dt>Description:</dt>
        <dd>{{ ast.description }}</dd>
      </div>
    </dl>
  }
}
